document.addEventListener("DOMContentLoaded", () => {
  console.log("Bundle script loaded");

  const originalFetch = window.fetch;

  window.fetch = async function(url, options = {}) {
    try {
      // Only intercept Shopify Cart Add API
      if (typeof url === "string" && url.includes("/cart/add")) {

        console.log("🔥 /cart/add detected → checking cart");

        const body = options?.body ? JSON.parse(options.body) : null;

        if (body?.items?.length === 1) {
          const item = body.items[0];

          // Check if selected variant is your bundle variant
          const bundleVariantId = 51206514933976; // your fake bundle variant ID

          if (item.id === bundleVariantId) {
            console.log("🔥 Bundle selected → replacing with real variants");

            const MINI_BLINIS_ID   = 50218588799192;
            const CREME_FRAICHE_ID = 50218584998104;

            const newPayload = {
              items: [
                { id: MINI_BLINIS_ID,   quantity: item.quantity },
                { id: CREME_FRAICHE_ID, quantity: item.quantity }
              ]
            };

            console.log("🔥 Sending this instead:", newPayload);

            return originalFetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(newPayload)
            });
          }
        }
      }

      // All other fetch requests must stay untouched
      return originalFetch(url, options);

    } catch (err) {
      console.error("Bundle script error:", err);
      return originalFetch(url, options);
    }
  };
});
